namespace TabAurous.Inventory {
    export interface SKURepricingForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        AutoPosting: Serenity.BooleanEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        Details: SKURepricingDetailsEditor;
        Items: SKURepricingItemsEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        SKUSelected: Serenity.StringEditor;
        LineNoSelected: Serenity.StringEditor;
        ProductIdSelected: Serenity.StringEditor;
        AttributeIdSelected: Serenity.StringEditor;
    }

    export class SKURepricingForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SKURepricing';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SKURepricingForm.init)  {
                SKURepricingForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = LabelEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.LookupEditor;
                var w6 = SKURepricingDetailsEditor;
                var w7 = SKURepricingItemsEditor;

                Q.initFormType(SKURepricingForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'Posted', w2,
                    'AutoPosting', w3,
                    'VoucherNo', w0,
                    'VoucherTypeId', w4,
                    'UserId', w5,
                    'EmployeeId', w4,
                    'Details', w6,
                    'Items', w7,
                    'CompanyId', w4,
                    'FinancialYearId', w4,
                    'SKUSelected', w0,
                    'LineNoSelected', w0,
                    'ProductIdSelected', w0,
                    'AttributeIdSelected', w0
                ]);
            }
        }
    }
}
